/**
 * Created by Ning Jiang on 11/22/2016.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {GameModelEvent} from "@nolimitcity/slot-game/bin/model/GameModel";
import {LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {KitchenDramaSushiManiaGameAssets} from "./KitchenDramaSushiManiaGameAssets";
import {KitchenDramaSushiManiaSound} from "./sound/KitchenDramaSushiManiaSound";
import {KitchenDramaSushiManiaBackgroundElements} from "./view/KitchenDramaSushiManiaBackgroundElements";
import {KitchenDramaSushiManiaWinPresentation} from "./gameflow/KitchenDramaSushiManiaWinPresentation";
import {KitchenDramaSushiManiaNormalBetPresentation} from "./gameflow/KitchenDramaSushiManiaNormalBetPresentation";
import {
    KitchenDramaSushiManiaNormalResultPresentation
} from "./gameflow/KitchenDramaSushiManiaNormalResultPresentation";
import {KitchenDramaSushiManiaIdleNormalPresentation} from "./gameflow/KitchenDramaSushiManiaIdleNormalPresentation";
import {KitchenDramaSushiManiaZeroBetIdlePresentation} from "./gameflow/KitchenDramaSushiManiaZeroBetIdlePresentation";
import {KitchenDramaSushiManiaGameData} from "./server/KitchenDramaSushiManiaData";
import {KitchenDramaSushiManiaModel} from "./server/KitchenDramaSushiManiaModel";
import {KitchenDramaSushiManiaReelsView} from "./reels/KitchenDramaSushiManiaReelsView";
import {SushiCollectView} from "./view/SushiCollectView";
import {KamisabiCollectView} from "./view/KamisabiCollectView";
import {KamisabiSplashView} from "./view/KamisabiSplashView";
import {KitchenDramaSushiManiaGameMode} from "./server/KitchenDramaSushiManiaGameMode";
import {TransitionScreenView} from "./view/TransitionScreenView";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {SushiFsMeterView} from "./view/SushiFsMeterView";
import {KitchenDramaSushiManiaWinView} from "./view/KitchenDramaSushiManiaWinView";
import {NinjaSplashView} from "./view/NinjaSplashView";
import {KitchenDramaBigWinDisplay} from "./view/KitchenDramaBigWinDisplay";
import {KitchenDramaSushiManiaStatics} from "./utils/KitchenDramaSushiManiaStatics";
import {TemplateAsset, TemplateLoader} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";
import { KitchenDramaScalingLayer } from "./view/KitchenDramaScalingLayer";

export class KitchenDramaSushiMania extends SlotGame {
    public static model:KitchenDramaSushiManiaModel;
    public static assetLoader:AssetLoader;
    public static soundPlayer:KitchenDramaSushiManiaSound;
    public static backgroundElements:KitchenDramaSushiManiaBackgroundElements;
    public static gameFlowController:GameFlowController;
    public static reelView:KitchenDramaSushiManiaReelsView;
    public static sushiCollectView:SushiCollectView;
    public static kamisabiCollectView:KamisabiCollectView;
    public static kamisabiSplashView:KamisabiSplashView;
    public static transitionScreen:TransitionScreenView;
    public static sushiFsMeterView:SushiFsMeterView;
    public static winView:KitchenDramaSushiManiaWinView;
    public static ninjaSplashView:NinjaSplashView;
    public static bigWinView:KitchenDramaBigWinDisplay;
    private static scalingLayer:KitchenDramaScalingLayer;


    constructor() {
        super();
    }


    private static getBuyFeaturePrice():number {
        const betLevel:string = KitchenDramaSushiMania.apiPlugin.freeBets.hasFreeBets() ? KitchenDramaSushiMania.apiPlugin.freeBets.getBet() : KitchenDramaSushiMania.apiPlugin.betLevel.getLevel();
        let price:number = KitchenDramaSushiMania.model.gameData?.playedBetValue || parseFloat(betLevel);
        return price;
    }


    public static isWinBelowStake(accumulatedRoundWin:number):boolean {
        return KitchenDramaSushiMania.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (accumulatedRoundWin <= this.getBuyFeaturePrice());
    }

    getNoWinGameData():any {
        return {
            "reels":[
                [
                    [
                        "L2",
                        "L4",
                        "M2"
                    ],
                    [
                        "L3",
                        "L4",
                        "L2"
                    ],
                    [
                        "M2",
                        "M2",
                        "M3"
                    ],
                    [
                        "L3",
                        "L4",
                        "L4"
                    ],
                    [
                        "M4",
                        "L1",
                        "L3"
                    ]
                ]
            ],
            "mode":"NORMAL",
            "avalancheWins":[],
            "betLineWins":[],
            "avalancheWinInfo":[
                {
                    "avalancheWin":0,
                    "multipliedAvalancheWin":0,
                    "mode":"NORMAL",
                    "wildSymbols":[],
                    "sushiModeCollectedWinsBeforeSpin":0,
                    "sushiModeCollectedWinsAfterSpin":0,
                    "winSize":"",
                    "collectedFreespinTriggerSymbols":[],
                    "secondChanceAvalancheCount":0,
                    "clientAccumulatedWin":0
                }
            ],
            "totalRoundWin":0,
            "accumulatedWinBeforeSpin":0,
            "reelsEnteringFreespin":[
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ]
            ],
            "totalSpinWin":0,
            "playedBetValue":1,
            "freespinTriggeredThisSpin":false,
            "nextMode":"NORMAL",
            "kamisabiRemove":[
                null
            ],
            "overlayWilds":[
                null
            ]
        }
    };

    public init():Promise<NolimitPlugin> {
        return super.init().then((value:NolimitPlugin) => {
            KitchenDramaSushiMania.model = new KitchenDramaSushiManiaModel(SlotGame.apiPlugin, true);
            KitchenDramaSushiMania.gameFlowController = new GameFlowController(SlotGame.apiPlugin, KitchenDramaSushiMania.model);
            KitchenDramaSushiMania.gameFlowController.flowStateLogger.level = LogLevel.DEV;

            //Example
            KitchenDramaSushiMania.model.events?.on(GameModelEvent.INIT, (data:KitchenDramaSushiManiaGameData) => {
                console.log(data);
            });
            KitchenDramaSushiMania.model.events?.on(GameModelEvent.GAME, (data:KitchenDramaSushiManiaGameData) => {
                console.log(data);
            });

            const winPres = new KitchenDramaSushiManiaWinPresentation();
            const reelStart = new KitchenDramaSushiManiaNormalBetPresentation();
            const normalResult = new KitchenDramaSushiManiaNormalResultPresentation();


            KitchenDramaSushiMania.gameFlowController.addGameModeFlowStatePresentationMap(KitchenDramaSushiManiaGameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, new KitchenDramaSushiManiaIdleNormalPresentation()],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winPres]
            ]));
            KitchenDramaSushiMania.gameFlowController.addGameModeFlowStatePresentationMap(KitchenDramaSushiManiaGameMode.WILD_SUSHI, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, new KitchenDramaSushiManiaZeroBetIdlePresentation()],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winPres]
            ]));


            return value;
        });
    }

    public getReady():Promise<NolimitPlugin> {
        //Show intro and load game assets
        return super.getReady().then((value:NolimitPlugin) => {

            const fontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);

            const imageLoader = new ImgLoader(NolimitApplication.resourcePath + "/resources/images/");
            imageLoader.add("sushiBannerTexture", "sushiBannerTexture.png")
            imageLoader.add("sushi_outro-decor", "sushi_outro-decor.png")
            imageLoader.add("checkerTile", "checkerTile.png")

            AssetsConfig.addToAssetsConfig(KitchenDramaSushiManiaGameAssets.RESOURCES_GROUPS);
            KitchenDramaSushiMania.assetLoader = new AssetLoader(KitchenDramaSushiMania.apiPlugin, NolimitApplication.resourcePath + "/resources/");

            const promises = Promise.all([fontLoader.load(), imageLoader.load(), KitchenDramaSushiMania.assetLoader.load(ResourcesGroupName.MAIN)]);

            return promises.then((values:any) => {

                this.createViewsAndComponents();

                if(KitchenDramaSushiMania.model.initData.isRestoreState && !KitchenDramaSushiMania.model.initData.freespinTriggeredThisSpin) {
                    KitchenDramaSushiMania.backgroundElements.setMode(KitchenDramaSushiMania.model.data.nextMode);
                    KitchenDramaSushiMania.kamisabiCollectView.hide();
                    KitchenDramaSushiMania.sushiCollectView.hide();
                    KitchenDramaSushiMania.sushiFsMeterView.show();
                    KitchenDramaSushiMania.sushiFsMeterView.setLevel(KitchenDramaSushiMania.model.initData.symbolWinsCollectedInSushiMode);
                    KitchenDramaSushiMania.keypadPlugin.setWin(KitchenDramaSushiMania.model.initData.accumulatedRoundWin, true, KitchenDramaSushiMania.isWinBelowStake(KitchenDramaSushiMania.model.initData.accumulatedRoundWin));
                } else {
                    KitchenDramaSushiMania.sushiFsMeterView.hide();
                }


                return value;
            });
        });
    }

    public getReadyToStart():Promise<NolimitPlugin> {
        //Game assets loaded, waiting for user to start game.
        return super.getReadyToStart().then((value:NolimitPlugin) => {
            return value;
        });
    }

    public start():Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.
        return super.start().then((value:NolimitPlugin) => {
            KitchenDramaSushiMania.gameFlowController.start();
            KitchenDramaSushiMania.soundPlayer.switchMusic(KitchenDramaSushiMania.model.data.mode);
            return value;
        });
    }

    private createViewsAndComponents() {


        KitchenDramaSushiMania.scalingLayer = new KitchenDramaScalingLayer();

        //Non views
        KitchenDramaSushiMania.soundPlayer = new KitchenDramaSushiManiaSound();

        //Static views
        KitchenDramaSushiMania.backgroundElements = new KitchenDramaSushiManiaBackgroundElements();
        KitchenDramaSushiMania.backgroundElements.setMode(KitchenDramaSushiManiaGameMode.NORMAL);
        KitchenDramaSushiMania.reelView = new KitchenDramaSushiManiaReelsView();
        KitchenDramaSushiMania.sushiCollectView = new SushiCollectView();
        KitchenDramaSushiMania.kamisabiCollectView = new KamisabiCollectView();
        KitchenDramaSushiMania.kamisabiSplashView = new KamisabiSplashView();
        KitchenDramaSushiMania.ninjaSplashView = new NinjaSplashView();
        KitchenDramaSushiMania.sushiFsMeterView = new SushiFsMeterView();

        KitchenDramaSushiMania.transitionScreen = new TransitionScreenView();
        KitchenDramaSushiMania.winView = new KitchenDramaSushiManiaWinView();
        KitchenDramaSushiMania.bigWinView = new KitchenDramaBigWinDisplay();

        NolimitApplication.addLayerAt(KitchenDramaSushiMania.bigWinView.name, KitchenDramaSushiMania.bigWinView, 0);
        NolimitApplication.addLayerAt(KitchenDramaSushiMania.winView.name, KitchenDramaSushiMania.winView, 0);
        NolimitApplication.addLayerAt(KitchenDramaSushiMania.transitionScreen.name, KitchenDramaSushiMania.transitionScreen, 0);
        NolimitApplication.addLayerAt(KitchenDramaSushiMania.ninjaSplashView.name, KitchenDramaSushiMania.ninjaSplashView, 0);
        NolimitApplication.addLayerAt(KitchenDramaSushiMania.kamisabiSplashView.name, KitchenDramaSushiMania.kamisabiSplashView, 0);

        NolimitApplication.addLayerAt(KitchenDramaSushiMania.scalingLayer.name, KitchenDramaSushiMania.scalingLayer, 0);
        KitchenDramaSushiMania.scalingLayer.addLayerAt(KitchenDramaSushiMania.reelView.name, KitchenDramaSushiMania.reelView, 0);
        KitchenDramaSushiMania.scalingLayer.addLayerAt(KitchenDramaSushiMania.kamisabiCollectView.name, KitchenDramaSushiMania.kamisabiCollectView, 0);
        KitchenDramaSushiMania.scalingLayer.addLayerAt(KitchenDramaSushiMania.sushiCollectView.name, KitchenDramaSushiMania.sushiCollectView, 0);
        KitchenDramaSushiMania.scalingLayer.addLayerAt(KitchenDramaSushiMania.sushiFsMeterView.name, KitchenDramaSushiMania.sushiFsMeterView, 0);
        KitchenDramaSushiMania.scalingLayer.addLayerAt(KitchenDramaSushiMania.backgroundElements.name, KitchenDramaSushiMania.backgroundElements, 0);

        KitchenDramaSushiMania.scalingLayer.onResize();

    }

    public getPaytable():Promise<string> {
        const templateLoader = new TemplateLoader(SlotGame.apiPlugin.resources.getStaticRoot());
        templateLoader.add({
            name:"Paytable",
            url:"nolimit/screens/paytable.mustache"
        });

        let symbolDataValueData = KitchenDramaSushiManiaStatics.defaultSymbolValues;
        if (KitchenDramaSushiMania.model?.symbolValues) {
            symbolDataValueData = KitchenDramaSushiMania.model.symbolValues;
            console.log("Using symbolValues from INIT data");
        } else {
            console.log("Using default symbolValues ");
        }

        return templateLoader.load().then((assets:TemplateAsset[]) => {
            for (let asset of assets) {
                if (asset.name == "Paytable" && asset.loadedData) {
                    for (let key in symbolDataValueData) {
                        asset.loadedData = asset.loadedData!.replace(`{{${key}}}`, this.getSymbolString(key, symbolDataValueData[key]))
                    }
                    return asset.loadedData;
                }
            }
            throw new Error("SlotGame could not load Paytable");
        });
    }

    public getSymbolString(key:string, data:{3:number, 4:number, 5:number}):string {
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/${key}.png">
            <div class="payout-group">
                <div class="payout">
                    <span class="number">5</span>
                    <span class="multiplier" data-multiplier="${data[5] * 0.05}">${data[5] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">4</span>
                    <span class="multiplier" data-multiplier="${data[4] * 0.05}">${data[4] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">3</span>
                    <span class="multiplier" data-multiplier="${data[3] * 0.05}">${data[3] * 0.05}</span>
                </div>
            </div>
            </div>
        `;


    }

}